import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import '../CSS/IncentiveConfiguration.css';
import Sidebar from '../Component/Sidebar';
const initialData = [
  {
    storeName: 'Kent Carol, Kent',
    customerTheftReported: 10,
    customerTheftPrevented: 23,
    cashierSuspicious: 20,
    cashierFraud: 370,
    category: 'Medium',
  },
  {
    storeName: 'Hillsboro, TX Station',
    customerTheftReported: 12,
    customerTheftPrevented: 5,
    cashierSuspicious: 8,
    cashierFraud: 150,
    category: 'Super',
  },
  {
    storeName: 'McKinney, TX Market',
    customerTheftReported: 7,
    customerTheftPrevented: 10,
    cashierSuspicious: 3,
    cashierFraud: 90,
    category: 'Medium',
  },
  {
    storeName: 'Lewis Hall, TX Austin',
    customerTheftReported: 11,
    customerTheftPrevented: 4,
    cashierSuspicious: 2,
    cashierFraud: 50,
    category: 'Super',
  },
];

function IncentiveConfiguration() {
  // Filters
  const [storeName, setStoreName] = useState('All Stores');
  const [category, setCategory] = useState('All Categories');
  const [searchTerm, setSearchTerm] = useState('');

  // Data
  const [data] = useState(initialData);

  // Filtered table rows
  const filteredData = data.filter((row) => {
    // Filter by store name
    const matchesStore =
      storeName === 'All Stores' || row.storeName === storeName;

    // Filter by category
    const matchesCategory =
      category === 'All Categories' || row.category === category;

    // Filter by search term (in any relevant field)
    const searchTermLower = searchTerm.toLowerCase();
    const matchesSearch =
      !searchTerm ||
      row.storeName.toLowerCase().includes(searchTermLower) ||
      row.customerTheftReported.toString().includes(searchTermLower) ||
      row.customerTheftPrevented.toString().includes(searchTermLower) ||
      row.cashierSuspicious.toString().includes(searchTermLower) ||
      row.cashierFraud.toString().includes(searchTermLower) ||
      row.category.toLowerCase().includes(searchTermLower);

    return matchesStore && matchesCategory && matchesSearch;
  });

  // Handle Excel Export
  const handleExportExcel = () => {
    // 1. Convert the filtered data into a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // 2. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // 3. Write the workbook to a buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // 4. Create a Blob from the buffer
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // 5. Save the file
    saveAs(blob, 'IncentiveConfiguration.xlsx');
  };

  return (
<div className='index-box'>
        <Sidebar />
        <div>

    <div className="incentive-config-container">
      {/* Title */}
      <h2 className="incentive-config-title">Incentive Configuration</h2>

      {/* Tab Bar */}
      <div className="incentive-config-tabs">
        <button className="tab-button">Rule Engine</button>
        <button className="tab-button">Incentive Category</button>
        <button className="tab-button">Complete Transaction</button>
      </div>

      {/* Filter Bar */}
      <div className="incentive-config-filter-bar">
        <div className="incentive-config-filter-group">
          <label htmlFor="storeName">Store Name:</label>
          <select
            id="storeName"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
          >
            <option>All Stores</option>
            {/* Dynamically generate options from data */}
            {Array.from(new Set(data.map((d) => d.storeName))).map(
              (store, index) => (
                <option key={index} value={store}>
                  {store}
                </option>
              )
            )}
          </select>
        </div>

        <div className="incentive-config-filter-group">
          <label htmlFor="category">Category:</label>
          <select
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option>All Categories</option>
            <option>Medium</option>
            <option>Super</option>
          </select>
        </div>

        <div className="incentive-config-search">
          <input
            type="text"
            placeholder="Type here to search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="incentive-config-export">
          <button onClick={handleExportExcel}>Export Excel</button>
        </div>
      </div>

      {/* Table */}
      <table className="incentive-config-table">
        <thead>
          <tr>
            <th>Store Name</th>
            <th>Customer - Theft Reported</th>
            <th>Customer - Theft Prevented</th>
            <th>Cashier - Suspicious</th>
            <th>Cashier - Fraud</th>
            <th>Category</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, idx) => (
            <tr key={idx}>
              <td>{row.storeName}</td>
              <td>{row.customerTheftReported}</td>
              <td>{row.customerTheftPrevented}</td>
              <td>{row.cashierSuspicious}</td>
              <td>{row.cashierFraud}</td>
              <td>{row.category}</td>
              <td>
                <button className="edit-button">Edit</button>
                {/* Add more action buttons as needed */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
    </div>
  );
}

export default IncentiveConfiguration;
